import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ExportButton = (props) => {
	const [loading, setLoading] = useState(false);
	let sortedData = props.data
	.sort((a,b) => {
		return a.created_date - b.created_date;
	}).map((record) => {
		const {created_date, ...rest} = record;
		return rest; 
	});

	const download = () => {
		setLoading(true);
		const ws = XLSX.utils.json_to_sheet(sortedData);
		const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
		// var result = ws['B2'];
		// var result1 = ws['BB2'];
		// const myJsonString = JSON.stringify(result);
		// const myString = myJsonString.replace(/\D/g,'');
		// const myJsonString2 = JSON.stringify(result1);
		// const myString2 = myJsonString2.replace(/^(-)|[^0-9-]+/g, '$1');
		// const result2 = myString2.slice(0, -9);
		const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([buffer], {
			type:
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
		});

		FileSaver.saveAs(blob, `event_.xlsx`);
		setLoading(false);
	};

	return (
		<Button
			loading={loading}
			color="black"
			size="small"
			icon="download"
			content="Exportar Datos"
			onClick={() => download()}
		/>
	);
};

export default ExportButton;
